const MENTION_KEY = 'firstMention'

export const setFirstMention = () => {
  const isFirstMention = {
    status: true,
    time: new Date().getTime() + 1000 * 60 * 60, // 1 hour
  }
  sessionStorage.setItem(MENTION_KEY, JSON.stringify(isFirstMention))
}

export const isFirstMention = () => {
  const mention = sessionStorage.getItem(MENTION_KEY)
  console.log('获取到的mention', mention)

  if (mention) {
    console.log('有mention')

    const { status, time } = JSON.parse(mention)
    if (new Date().getTime() < time) {
      console.log('时间没到')

      return false
    }
  }
  removeFirstMention()
  return true
}

const removeFirstMention = () => {
  sessionStorage.removeItem(MENTION_KEY)
}
